import { render, staticRenderFns } from "./news-tags.vue?vue&type=template&id=6ee9c346&scoped=true&"
import script from "./news-tags.vue?vue&type=script&lang=ts&"
export * from "./news-tags.vue?vue&type=script&lang=ts&"
import style0 from "./news-tags.vue?vue&type=style&index=0&id=6ee9c346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee9c346",
  null
  
)

export default component.exports